module.exports = __webpack_public_path__ + "static/contactus-transparent-12abe7006c8e594e695d95da309208ac.png";